import { render } from "./NavigationMenu.vue?vue&type=template&id=c58d6ede&scoped=true&ts=true"
import script from "./NavigationMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationMenu.vue?vue&type=script&setup=true&lang=ts"

import "./NavigationMenu.vue?vue&type=style&index=0&id=c58d6ede&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c58d6ede"],['__file',"src/lib/components/onboarding/NavigationMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c58d6ede"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c58d6ede', __exports__)) {
    api.reload('c58d6ede', __exports__)
  }
  
  module.hot.accept("./NavigationMenu.vue?vue&type=template&id=c58d6ede&scoped=true&ts=true", () => {
    api.rerender('c58d6ede', render)
  })

}


export default __exports__